import { render, staticRenderFns } from "./profileSettings.vue?vue&type=template&id=011d40e8"
import script from "./profileSettings.vue?vue&type=script&lang=js"
export * from "./profileSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports